import React, { useState } from 'react';
import Modal from './Modal';
import axios from 'axios';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import Form from '../Form/Form';
import InputText from '../Form/Fields/InputText';
import Textarea from '../Form/Fields/Textarea';
import Button from '../Form/Button';
import { API_BASE_URL } from '../../api';

import './CreateProductModal.scss';

export default function HelpCategoryModal({ show, onClose, onSaved, category = null }) {
    const isEdit = category != null;
    const [isLoading, setIsLoading] = useState(false);

    const defaultValues = {
        label: category?.label ?? '',
        description: category?.description ?? '',
        icon: category?.icon ?? '',
        color: category?.color ?? '',
    };

    const onSubmit = (data) => {
        const request = isEdit
            ? axios.put(`${API_BASE_URL}/api/v1/backoffice/help/categories/${category.id}`, data, { withCredentials: true })
            : axios.post(`${API_BASE_URL}/api/v1/backoffice/help/categories`, data, { withCredentials: true });

        setIsLoading(true);
        request
            .then(() => {
                toast.success(isEdit ? 'Catégorie mise à jour.' : 'Catégorie créée.');
                onSaved();
                onClose();
            })
            .catch(() => toast.error('Une erreur est survenue.'))
            .finally(() => setIsLoading(false));
    };

    return (
        <Modal
            id="helpCategoryModal"
            title={isEdit ? 'Modifier la catégorie' : 'Nouvelle catégorie'}
            show={show}
            onClose={onClose}
            icon={faLayerGroup}
            iconBg="#e0e7ff"
            iconColor="#4338ca"
            footer={
                <Button isLoading={isLoading} loadingMessage="Enregistrement ..." type="submit" form="helpCategoryForm" className="modal-btn-primary">
                    {isEdit ? 'Enregistrer' : 'Créer'}
                </Button>
            }
        >
            <Form id="helpCategoryForm" onSubmit={onSubmit} defaultValues={defaultValues} key={category?.id ?? 'new'}>
                <div className="mb-3">
                    <label className="cdm-field-label">Nom <span className="text-danger">*</span></label>
                    <InputText
                        name="label"
                        placeholder="ex: Produits & Stock"
                        validationRules={{ required: 'Le nom est requis' }}
                    />
                </div>
                <div className="mb-3">
                    <label className="cdm-field-label">Description</label>
                    <Textarea name="description" placeholder="Courte description affichée sur la page d'accueil du centre d'aide" />
                </div>
                <div className="row">
                    <div className="col-md-6 mb-3">
                        <label className="cdm-field-label">Icône (FontAwesome)</label>
                        <InputText name="icon" placeholder="ex: faBoxes" />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="cdm-field-label">Couleur</label>
                        <InputText name="color" placeholder="ex: #2563eb" />
                    </div>
                </div>
            </Form>
        </Modal>
    );
}
